<template>
  <div :id="id"
       class="o-echarts"></div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import moment from 'moment'
let chart = null
export default {
  name: 'ByInsuranceChart',
  props: {
    id: {
      type: String,
      required: false,
      default: 'chart'
    },
    subtext: {
      type: String,
      required: false,
      default: moment().format('YYYY年MM月DD日')
    }
  },
  data () {
    return {
      // id: 'byInsuranceChart',//地图渲染容器id
      option: {
        title: {
          text: '',
          subtext: '（2020年4月26日）',
          left: 'right',
          top: -15
        },
        tooltip: {
          trigger: 'axis'
        },
        dataZoom: [
          {
            type: 'slider',
            show: false, // flase直接隐藏图形
            xAxisIndex: [0],
            left: '9%', // 滚动条靠左侧的百分比
            bottom: -5,
            start: 0, // 滚动条的起始位置
            end: 50 // 滚动条的截止位置（按比例分割你的柱状图x轴长度）
          }
        ],

        dataset: {
          // dimensions: ['insurance', '水稻政策性保险', '大豆政策性保险', '玉米政策性保险'],
          // source: [
          //   { insurance: '阳光保险', '水稻政策性保险': 1000, '大豆政策性保险': 1500, '玉米政策性保险': 1200 },
          //   { insurance: '太平洋保险', '水稻政策性保险': 2000, '大豆政策性保险': 1800, '玉米政策性保险': 1600 },
          //   { insurance: '安信保险', '水稻政策性保险': 5000, '大豆政策性保险': 2000, '玉米政策性保险': 3000 },
          //   { insurance: '平安保险', '水稻政策性保险': 10000, '大豆政策性保险': 5000, '玉米政策性保险': 8000 },
          // ]
        },
        legend: {
          top: 16,
          itemGap: 10,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#333'
          },
          icon: 'rect'
          // data: ["水稻政策性保险", "大豆政策性保险", "玉米政策性保险"]
        },
        grid: {
          left: 50,
          right: 10
        },
        toolbox: {
          show: true
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // data: ["阳光保险 ", "太平洋保险", "安信保险", "平安保险"],

            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#aaa',
                type: 'dotted'
              }
            },
            axisLabel: {
              color: '#333',
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLine: {
              show: false
            }
          }
        ],
        color: ['#6f7dfa', '#4ab1e9', '#13d7d6'],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: 14
            // name: "水稻政策性保险",
            // data: [1000, 2000, 5000, 10000]
          },
          {
            name: '',
            type: 'bar',
            barWidth: 14
            // name: "大豆政策性保险",
            // data: [1500, 1800, 3000, 5000],
          },
          {
            name: '',
            type: 'bar',
            barWidth: 14
            // name: "玉米政策性保险",
            // data: [1200, 1600, 2000, 8000],
          },
          {
            name: '',
            type: 'bar',
            barWidth: 14,
            color: '#ff9023'
            // name: "玉米政策性保险",
            // data: [1200, 1600, 2000, 8000],
          }
        ]
      }
    }
  },
  mounted () {
    // this.initMap()
  },
  watch: {},
  methods: {
    listenResize () {
      // 窗口改变大小
      if (chart) {
        chart.resize()
      }
    },
    initMap (optionData) {
      // 设置时间
      this.option.title.subtext = optionData.date || ''
      // this.option.legend.data = optionData.legend
      // this.option.xAxis[0].data = optionData.xAxis
      if (optionData.dataZoom) {
        this.option.dataZoom[0].show = optionData.dataZoom
      }

      this.option.dataset = optionData.dataset || []
      chart = echarts.init(document.getElementById(this.id))
      chart.setOption(this.option)
      if (optionData.chartHeight) {
        chart.resize({ height: optionData.chartHeight })
      } else {
        chart.resize({ height: 300 })
      }
    }
  },
  components: {}
}
</script>

<style scoped lang="less">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/ByInsuranceChart.vue